import { cn } from "@app/lib/utils";

interface ArrowLinkProps {
  color?: string;
}

/**
 * Arrow link component for sector cards
 * Displays an animated arrow icon with hover effects
 */
export function ArrowLink({ color }: ArrowLinkProps) {
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="group visible relative overflow-visible w-full h-full"
    >
      <path
        d="M0 32C0 14.3269 14.3269 0 32 0H121C138.673 0 153 14.3269 153 32V121C153 138.673 138.673 153 121 153H32C14.3269 153 0 138.673 0 121V32Z"
        fill={color || "#011E62"}
        className={cn(
          "absolute origin-center -rotate-90 transition-all duration-500 ease-in-out",
          "group-hover:top-[200px] group-hover:rotate-0 group-hover:fill-[#0046bb]"
        )}
      />

      <path
        d="M73.7891 56.4025H41.2891"
        stroke="white"
        strokeWidth="3.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={cn(
          "absolute left-0 top-0 origin-center scale-x-[1]",
          "transition-transform duration-500 ease-in-out group-hover:scale-x-[1.1]"
        )}
      />

      <path
        d="M60.6798 43.3514C60.6798 43.3514 73.7881 50.4169 73.7881 56.4012C73.7881 62.3899 60.6798 69.4575 60.6798 69.4575"
        stroke="white"
        strokeWidth="3.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}